// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"64ec279c","732":"aaa947fe","977":"433e5838"}[chunkId] + ".chunk.js";
};